import { useEffect, useMemo, useState } from "react";
import useSWRImmutable from "swr/immutable";

import useSWRInfinite from "swr/infinite";
import { fetchWithFBToken } from "../Common/swrMiddlewares";
import { useProfile } from "./useProfile";

const LIMIT = 100;
export const LIKE = "LIKE";
export const LOVE = "LOVE";

const REACTION_GLOBAL_STATE = "REACTION_GLOBAL_STATE";

export const useFbReactionsHashMap = (objectId) => {
  return useSWRImmutable(`${REACTION_GLOBAL_STATE}_${objectId}`, () => ({}));
};

export const useFbReactions = (objectId, option) => {
  const { profile } = useProfile();
  const [totalCount, setTotalCount] = useState(0);
  const link = `${process.env.REACT_APP_GRAPH_API_URL}/${objectId}/reactions?summary=total_count&limit=${LIMIT}`;
  const { mutate: mutateHashMap } = useFbReactionsHashMap(objectId);
  const res = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (!profile || !objectId) {
        return null;
      } else if (previousPageData && !previousPageData.paging.next) {
        return null;
      } // reached the end
      else if (pageIndex === 0) {
        return link;
      }
      return `${link}&after=${previousPageData.paging.cursors.after}`;
    },
    {
      ...option,
      use: [fetchWithFBToken],
      //   refreshInterval: 30 * 1000,
      onSuccess: (data) => {
        if (data && data.summary && data.summary.total_count !== totalCount) {
          setTotalCount(data.summary.total_count);
        }
      },
    }
  );
  const { data, error, isLoading, isValidating, size, setSize, mutate } = res;

  useEffect(() => {
    setSize(Math.floor(totalCount / LIMIT) + 1);
  }, [totalCount]); //only check totalCount

  const { reactions, reactionsHashMap } = useMemo(() => {
    const reactions = data ? data.flatMap((d) => d.data) : [];
    const reactionsHashMap = reactions.reduce(
      (acc, cur) => ({ ...acc, [cur.id]: cur }),
      {}
    );
    return { reactions, reactionsHashMap };
  }, [data]);

  useEffect(() => {
    mutateHashMap(reactionsHashMap, { revalidate: false });
  }, [mutateHashMap, reactionsHashMap]);

  const isLoadingMore =
    isLoading || (size > 0 && data && typeof data[size - 1] === "undefined");

  const isEmpty = data?.[0]?.length === 0;

  const isReachingEnd =
    isEmpty || (data && data[data.length - 1]?.length < LIMIT);

  const isRefreshing = isValidating && data && data.length === size;

  return {
    reactions,
    reactionsHashMap,
    isLoadingMore,
    isEmpty,
    isReachingEnd,
    isRefreshing,
    mutate,
    error,
  };
};
